import { jsx as _jsx } from "react/jsx-runtime";
import styles from './FooterCopyright.module.scss';
import cx from 'classnames';
export const FooterCopyright = ({ text, isFooterLinksSortActive }) => (_jsx("p", { className: cx(styles['footer__copyright-p'], isFooterLinksSortActive
        ? styles['footer__copyright__alignment__sort-p']
        : styles['footer__copyright__alignment-p']), children: text }));
